import { PrebuildPhase } from "gitpod-next-api/gitpod/v1/prebuild_pb";

export function statusInfo(
    phase?: PrebuildPhase,
    desiredPhase?: PrebuildPhase,
    snapshotCompletionPercentage?: number,
): {
    label: string;
    icon: "spinner" | "success" | "error" | "cancelled";
} {
    // Check if prebuild is in a finished state
    const finished =
        phase === PrebuildPhase.COMPLETED ||
        phase === PrebuildPhase.FAILED ||
        phase === PrebuildPhase.CANCELLED ||
        phase === PrebuildPhase.DELETED;

    // Optimistically show cancelling/deleting state when desired phase is set but not yet reached
    if (desiredPhase === PrebuildPhase.CANCELLED && !finished) {
        return { label: "Cancelling", icon: "spinner" };
    }
    if (desiredPhase === PrebuildPhase.DELETED && phase !== PrebuildPhase.DELETED) {
        return { label: "Deleting", icon: "spinner" };
    }

    switch (phase) {
        case PrebuildPhase.PENDING:
        case PrebuildPhase.STARTING:
            return { label: "Starting", icon: "spinner" };
        case PrebuildPhase.RUNNING:
            return { label: "Running", icon: "spinner" };
        case PrebuildPhase.STOPPING:
            return { label: "Stopping", icon: "spinner" };
        case PrebuildPhase.SNAPSHOTTING:
            if (snapshotCompletionPercentage && snapshotCompletionPercentage > 0) {
                return { label: `Snapshotting ${snapshotCompletionPercentage}%`, icon: "spinner" };
            }
            return { label: "Snapshotting", icon: "spinner" };
        case PrebuildPhase.COMPLETED:
            return { label: "Succeeded", icon: "success" };
        case PrebuildPhase.FAILED:
            return { label: "Failed", icon: "error" };
        case PrebuildPhase.CANCELLING:
            return { label: "Cancelling", icon: "spinner" };
        case PrebuildPhase.CANCELLED:
            return { label: "Cancelled", icon: "cancelled" };
        case PrebuildPhase.DELETING:
            return { label: "Deleting", icon: "spinner" };
        case PrebuildPhase.DELETED:
            return { label: "Deleted", icon: "spinner" };
        default:
            return { label: "—", icon: "spinner" };
    }
}
